import React from 'react'

import { Portlet, Row, Col, Button, Form, AsyncSelect } from '_zari/core'

import { ZariContext } from '_zari/context'
import { AdminContext } from 'contexts/AdminContext'

import * as ProductoCrud from 'services/producto.service'
import * as InventarioCrud from 'services/inventario.service'

import { ClearInputGroup } from 'sharedComponents/utils'

import { MesContabilidadSelect, SelectSede } from 'sharedComponents/select'

import { DownloadAxiosFile } from 'utils'

const Formato12_1 = () => {
  const __zariContext = React.useContext(ZariContext)
  const __adminContext = React.useContext(AdminContext)

  const [idProducto, setIdProducto] = React.useState('')
  const [nombreProducto, setNombreProducto] = React.useState('')
  const [mesSeleccionado, setMesSeleccionado] = React.useState(__adminContext.mesTrabajo)
  const [idSede, setIdSede] = React.useState('')
  const [resultados, setResultados] = React.useState(null)
  const [buscando, setBuscando] = React.useState(false)

  const getParams = () => ({ idProducto, idSede, mesSeleccionado })

  const clickDescargarReporteHandler = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte - Formato 12.1...')
    InventarioCrud.getReporteFormato12_1(getParams())
      .then(({ data, headers }) => {
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, idProducto, idSede, mesSeleccionado])

  const clickBuscar = React.useCallback(() => {
    setBuscando(true)
    InventarioCrud.consultaFormato12p1(getParams())
      .then(({ data }) => setResultados(data))
      .catch(({ data }) => __zariContext.snack('error', data?.error || 'Error al consultar'))
      .finally(() => setBuscando(false))
  }, [__zariContext, idProducto, idSede, mesSeleccionado])

  const loadProductosSelect = (inputValue, resolve) => {
    ProductoCrud.obtenerAsSelect2({ busqueda: inputValue }).then(({ data }) => resolve(data))
  }

  const onChangeProductoHandler = idProducto => {
    ProductoCrud.getProducto(idProducto.value).then(({ data }) => {
      setIdProducto(idProducto.value)
      setNombreProducto(data.nombre)
    })
  }

  const clickClear = () => {
    setIdProducto(null)
    setNombreProducto('')
  }

  return (
    <Portlet>
      <Portlet.Header title='Reporte - Formato 12.1' />
      <Portlet.Body>
        <Row className='mb-2'>
          <Col md={12}>
            <Form.Group>
              <Form.Label text='PRODUCTO' htmlFor='producto' sm={2} />
              <Col md={10}>
                {idProducto ? (
                  <ClearInputGroup id='input-producto-data-121' iValue={`${nombreProducto}`} clickClear={clickClear} />
                ) : (
                  <AsyncSelect selectId='productoSelect-121' loadOptions={loadProductosSelect} onChange={onChangeProductoHandler} />
                )}
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='MES' htmlFor='select-mes' md={4} alignRightAt='md' />
              <Col md={8}>
                <MesContabilidadSelect name='select-mes' id='select-mes' value={mesSeleccionado} onChange={e => setMesSeleccionado(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group>
              <Form.Label text='ESTABLECIMIENTO' htmlFor='select-sede' md={4} alignRightAt='md' />
              <Col md={8}>
                <SelectSede id='select-sede-121' name='select-sede-121' value={idSede} onChange={e => setIdSede(e.target.value)} />
              </Col>
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col md={12} className='text-right'>
            <Button variant='outline-primary' onClick={clickBuscar} disabled={buscando} className='mr-2'>
              {buscando ? 'Buscando...' : 'Buscar'}
            </Button>
            <Button onClick={clickDescargarReporteHandler}>Descargar</Button>
          </Col>
        </Row>

        {resultados && (
          <Row className='mt-3'>
            <Col md={12}>
              <div style={{ maxHeight: 500, overflowY: 'auto' }}>
                <table className='table table-sm table-striped table-bordered'>
                  <thead>
                    <tr>
                      <th>PRODUCTO</th>
                      <th>FECHA</th>
                      <th>T. DOC.</th>
                      <th>SERIE</th>
                      <th>NUMERO</th>
                      <th>T. OPERACION</th>
                      <th className='text-right'>ENTRADAS</th>
                      <th className='text-right'>SALIDAS</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultados.map((r, i) => (
                      <tr key={i}>
                        <td>{r.producto}</td>
                        <td>{r.fecha}</td>
                        <td>{r.tipoDocumento}</td>
                        <td>{r.serie}</td>
                        <td>{r.numero}</td>
                        <td>{r.tipoOperacion}</td>
                        <td className='text-right'>{r.entradas || ''}</td>
                        <td className='text-right'>{r.salidas || ''}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <small className='text-muted'>{resultados.length} registros encontrados</small>
            </Col>
          </Row>
        )}
      </Portlet.Body>
    </Portlet>
  )
}

export default React.memo(Formato12_1)
